import { useState } from "react";
import type { Company } from "../types";
import DarfAssignmentsPage from "./DarfAssignmentsPage";
import FgtsAssignmentsPage from "./FgtsAssignmentsPage";

type Flash = { kind: "ok" | "error"; text: string } | null;
type Props = { companies: Company[]; canManage: boolean; reload: () => void; flash: (value: Flash) => void; onRules: () => void };

export default function AssignmentsPage({ companies, canManage, reload, flash, onRules }: Props) {
  const [tab, setTab] = useState<"darf" | "fgts">("darf");
  return <>
    <div className="process-tabs" role="tablist" aria-label="Aplicação das regras">
      <button role="tab" aria-selected={tab === "darf"} className={tab === "darf" ? "selected" : ""} onClick={() => setTab("darf")}>Grupos DARF</button>
      <button role="tab" aria-selected={tab === "fgts"} className={tab === "fgts" ? "selected" : ""} onClick={() => setTab("fgts")}>FGTS Digital</button>
    </div>
    {tab === "darf" ? <DarfAssignmentsPage companies={companies} canManage={canManage} flash={flash} onConfigure={onRules} />
      : <FgtsAssignmentsPage companies={companies} canManage={canManage} reload={reload} flash={flash} />}
  </>;
}
